import { RegularExpressions } from '../constants/regular-expressions';

export function generateSecurePassword(length) {
  const chars =
    'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%&*()_-+=';
  let password: string;
  const generatePassword = () => {
    password = '';
    password = [...Array(length)].reduce((accumulator, _element) => {
      const randomIndex = Math.floor(Math.random() * chars.length);
      return accumulator + chars[randomIndex];
    }, '');
  };
//تا وقتی پسورد تولید شده با رجکس داده شده مطابقت نداشته باشه ، پسورد جدید میسازه
  generatePassword();
  while (!checkPassword(password)) {
    generatePassword();
    if (checkPassword(password)) return password;
  }
  if (checkPassword(password)) return password;
}

export function checkPassword(password: any): boolean {
  return RegularExpressions.securePassword.test(password?.toString());
}
